import React, { Component } from "react";
import { comma, commaString } from "utils/Utils";
import { observer } from "mobx-react";
import {
  fn_product_etc_pop,
  fn_salesProductSearch,
  fn_getDateTerm,
  fn_getDetailButtonView,
  fn_getSearchVal,
  fn_getSearchView,
  fn_getProductType,
  fn_setProductType,
  fn_getPriceType,
  fn_setPriceType,
  fn_setDateTerm,
  fn_setDetailButtonView,
  fn_setSearchVal,
  fn_setSearchView,
  fn_setSortVal,
  fn_getSortVal,
  fn_productSalesEtcList,
  fn_setBeforeDetailUpdate,
  fn_productSalesExcelList,
  fn_initSalesProductAll,
  fn_setChannelText,
  fn_initDetailButtonView,
} from "function/FnBodySales";
import SalesPagingBottomView from "./SalesPagingBottomView";
import SalesProductItemView from "./SalesProductItemView";
import EndDatePicker from "./EndDatePicker";
import StartDatePicker from "./StartDatePicker";
import { Link } from "react-router-dom";
import SalesDefaultLeftView from "./SalesDefaultLeftView";
import { partnerText, analyticeEvent } from "utils/Utils";
import { fn_auth_pop } from "function/FnBodyLayer";
import Chip from "components/ui/Chip";
import { Button } from "components/ui/Button";

@observer
class SalesProduct extends Component {
  inputBoxDel = e => {
    const { rootStore } = this.props;
    fn_setSearchVal(rootStore, "");
    document.getElementById("productName").value = "";
    fn_salesProductSearch(rootStore);
  };

  componentDidMount() {
    const { rootStore } = this.props;
    fn_initSalesProductAll(rootStore);
    fn_setDateTerm(rootStore, "today", true);
    fn_salesProductSearch(rootStore);
  }

  sortClick = type => {
    const { rootStore } = this.props;
    fn_setSortVal(rootStore, type, !fn_getSortVal(rootStore)[type].status);
    fn_salesProductSearch(rootStore);
  };

  item = (mode, pageNo) => {
    const { rootStore } = this.props;
    if (mode == "pre" && rootStore.salesStore.getChannelPageCnt > 1) {
      rootStore.salesStore.setChannelPageCnt(rootStore.salesStore.getChannelPageCnt - 1);
    }
    if (mode == "next" && rootStore.salesStore.getChannelPageCnt < pageNo) {
      rootStore.salesStore.setChannelPageCnt(rootStore.salesStore.getChannelPageCnt + 1);
    }
  };

  render() {
    const { rootStore } = this.props;
    const { salesStore } = rootStore;
    const pageNo = Math.ceil(Object.keys(rootStore.salesStore.getDetailButtonView).length / 12);
    const pageCnt = salesStore.getChannelPageCnt;
    const channelList = salesStore.getOrderChannelListView;

    return (
      <>
        <div className="article_setting">
          {/*왼쪽 메뉴 */}
          <SalesDefaultLeftView rootStore={rootStore} />
          <div className="section_content sales">
            <div className="top">
              <h3>판매상품별 매출내역</h3>
              <div className="sales close">
                <Link to="/">
                  <button type="button">
                    <span className="btn_order_history_close">닫기</span>
                  </button>
                </Link>
              </div>
            </div>
            <div className="scroll">
              <div className="inner">
                {rootStore.layerStore.getManagerAuthView.manager == "Y" ||
                rootStore.settingStore.getManagerSetting.salePage == "N" ||
                rootStore.layerStore.getManagerAuthView.auth == "Y" ? (
                  <div className="article_order_history">
                    <div
                      className={fn_getSearchView(rootStore).detail_area_view ? "bg" : "hide"}
                      onClick={event => {
                        fn_setSearchView(rootStore, "detail_area_view", !fn_getSearchView(rootStore).detail_area_view);
                        fn_setBeforeDetailUpdate(rootStore);
                      }}
                    ></div>
                    <div
                      className={fn_getSearchView(rootStore).key_area_view ? "bg" : "hide"}
                      onClick={event =>
                        fn_setSearchView(rootStore, "key_area_view", !fn_getSearchView(rootStore).key_area_view)
                      }
                    ></div>
                    <div className="section_order_history sales">
                      <div className="wrap_search">
                        <div className="box_date">
                          <div>
                            <div className="tit period">매출기간</div>
                            <div className="sub_txt">(영업일 기준)</div>
                          </div>
                          <div className="selects term">
                            <label
                              onClick={event => {
                                event.preventDefault();
                                fn_setDateTerm(rootStore, "today", true);
                                fn_salesProductSearch(rootStore);
                                analyticeEvent(
                                  "productSalesSearch",
                                  "productSalesSearchToday Button",
                                  rootStore.searchStore.getShopCd
                                );
                              }}
                            >
                              <input
                                type="radio"
                                name="date"
                                readOnly={true}
                                checked={fn_getDateTerm(rootStore).today === true}
                              />
                              <span className="txt today">오늘</span>
                            </label>
                            <label
                              onClick={event => {
                                event.preventDefault();
                                fn_setDateTerm(rootStore, "week", true);
                                fn_salesProductSearch(rootStore);
                                analyticeEvent(
                                  "productSalesSearch",
                                  "productSalesSearch7day Button",
                                  rootStore.searchStore.getShopCd
                                );
                              }}
                            >
                              <input
                                type="radio"
                                name="date"
                                readOnly={true}
                                checked={fn_getDateTerm(rootStore).week === true}
                              />
                              <span className="txt befor">일주일</span>
                            </label>
                            <label
                              onClick={event => {
                                event.preventDefault();
                                fn_setDateTerm(rootStore, "month", true);
                                fn_salesProductSearch(rootStore);
                                analyticeEvent(
                                  "productSalesSearch",
                                  "productSalesSearchMonth Button",
                                  rootStore.searchStore.getShopCd
                                );
                              }}
                            >
                              <input
                                type="radio"
                                name="date"
                                readOnly={true}
                                checked={fn_getDateTerm(rootStore).month === true}
                              />
                              <span className="txt week">이번달</span>
                            </label>
                          </div>
                          <label
                            className="date"
                            onClick={evnet =>
                              analyticeEvent(
                                "productSalesSearch",
                                "productSalesSearchDatePickerStart Button",
                                rootStore.searchStore.getShopCd
                              )
                            }
                          >
                            <StartDatePicker rootStore={rootStore} />
                            <span className="ico_date"></span>
                          </label>
                          <div className="txt_bar">-</div>
                          <label
                            className="date"
                            onClick={evnet =>
                              analyticeEvent(
                                "productSalesSearch",
                                "productSalesSearchDatePickerEnd Button",
                                rootStore.searchStore.getShopCd
                              )
                            }
                          >
                            <EndDatePicker rootStore={rootStore} />
                            <span className="ico_date"></span>
                          </label>
                          <button
                            type="button"
                            className="btn_refresh"
                            onClick={event => {
                              fn_initSalesProductAll(rootStore);
                              fn_setDateTerm(rootStore, "today", true);
                              fn_salesProductSearch(rootStore);
                              analyticeEvent(
                                "productSalesSearch",
                                "productSalesSearchReset",
                                rootStore.searchStore.getShopCd
                              );
                            }}
                          ></button>
                          <div className="search_box">
                            <button
                              type="submit"
                              className="btn_search"
                              onClick={event => {
                                fn_salesProductSearch(rootStore);
                                analyticeEvent(
                                  "productSalesSearch",
                                  "productSalesSearch",
                                  rootStore.searchStore.getShopCd
                                );
                              }}
                            >
                              조회
                            </button>
                          </div>
                        </div>
                        <div className="search_bg">
                          <div className="box_search">
                            <div className="tit">주문채널</div>
                            <div className="search">
                              <button
                                type="button"
                                className={
                                  fn_getSearchView(rootStore).detail_area_view
                                    ? "btn_detail_search on"
                                    : "btn_detail_search"
                                }
                                onClick={event => {
                                  fn_setSearchView(
                                    rootStore,
                                    "detail_area_view",
                                    !fn_getSearchView(rootStore).detail_area_view
                                  );
                                }}
                              >
                                <span>{rootStore.salesStore.getSalesProductChannel}</span>
                              </button>
                            </div>
                            <div className="tit">상품검색</div>
                            <div className="name_search">
                              <button
                                type="button"
                                className={salesStore.getProductNameSearchVal != "" ? "delete_ico" : "delete_ico hide"}
                                onClick={this.inputBoxDel}
                              >
                                <span className="screen_out">입력값 삭제</span>
                              </button>
                              <input
                                type="text"
                                id="productName"
                                value={fn_getSearchVal(rootStore) || ""}
                                placeholder="검색할 상품명을 입력하세요"
                                onChange={event => fn_setSearchVal(rootStore, event.target.value)}
                                onKeyPress={e => {
                                  if (e.key === "Enter") fn_salesProductSearch(rootStore);
                                }}
                              />
                            </div>
                          </div>
                          <div
                            className={
                              "layer_detail_search " +
                              (fn_getSearchView(rootStore).detail_area_view === true ? "open" : "")
                            }
                          >
                            <h5>주문채널을 선택해 주세요</h5>
                            <span
                              className="pop_close screen_out"
                              onClick={event => {
                                fn_setSearchView(
                                  rootStore,
                                  "detail_area_view",
                                  !fn_getSearchView(rootStore).detail_area_view
                                );
                                fn_setBeforeDetailUpdate(rootStore);
                              }}
                            >
                              닫기
                            </span>
                            <div className="inner order_channel">
                              <div className="w-full grid grid-cols-4 gap-3 pb-2 relative">
                                {Array.isArray(channelList[pageCnt - 1]) && channelList[pageCnt - 1].length > 0
                                  ? channelList[pageCnt - 1].map((obj, index) => (
                                      <Chip
                                        key={index}
                                        id={obj}
                                        name={obj}
                                        label={partnerText(obj)}
                                        checked={fn_getDetailButtonView(rootStore)[obj] ?? false} 
                                        onClick={() => {
                                          fn_setDetailButtonView(
                                            rootStore,
                                            obj,
                                            !fn_getDetailButtonView(rootStore)[obj]
                                          );
                                        }}
                                      />
                                    ))
                                  : null}
                              </div>
                              <div className="flex justify-end mt-3  gap-3">
                                <Button
                                  type="button"
                                  variant="disabled"
                                  onClick={() => {
                                    this.item("pre", pageNo);
                                  }}
                                  className="!p-[.35rem]"
                                  disabled={pageCnt === 1}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    className={`w-6 h-6 ${pageCnt === 1 ? "text-gray-500" : "text-black"}`}
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </Button>
                                <Button
                                  type="button"
                                  variant="disabled"
                                  onClick={event => {
                                    this.item("next", pageNo);
                                  }}
                                  className="!p-[.35rem]"
                                  disabled={pageCnt === pageNo}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    className={`w-6 h-6 ${pageCnt === pageNo ? "text-gray-500" : "text-black"}`}
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </Button>
                              </div>
                            </div>
                            <div className="btns">
                              <button
                                type="button"
                                className="reset"
                                onClick={event => {
                                  // fn_setSearchView(rootStore, 'detail_area_view', !fn_getSearchView(rootStore).detail_area_view);
                                  //fn_setBeforeDetailUpdate(rootStore);
                                  fn_initDetailButtonView(rootStore);
                                }}
                              >
                                설정초기화
                              </button>
                              <button
                                type="button"
                                className="search"
                                onClick={event => {
                                  fn_setSearchView(
                                    rootStore,
                                    "detail_area_view",
                                    !fn_getSearchView(rootStore).detail_area_view
                                  );
                                  fn_salesProductSearch(rootStore);
                                  fn_setChannelText(rootStore);
                                  analyticeEvent(
                                    "productSalesSearch",
                                    "productSalesSearchOrderChannel",
                                    rootStore.searchStore.getShopCd
                                  );
                                }}
                              >
                                적용
                              </button>
                            </div>
                          </div>
                          <div className="box_date">
                            <div className="tit">상품유형</div>
                            <div className="selects product">
                              <label
                                onClick={event => {
                                  event.preventDefault();
                                  fn_setProductType(rootStore, "all", true);
                                  fn_salesProductSearch(rootStore);
                                  analyticeEvent(
                                    "productSalesSearch",
                                    "productSalesSearchAllType Button",
                                    rootStore.searchStore.getShopCd
                                  );
                                }}
                              >
                                <input
                                  type="radio"
                                  name="product"
                                  readOnly={true}
                                  checked={fn_getProductType(rootStore).all === true}
                                />
                                <span className="txt today">전체</span>
                              </label>
                              <label
                                onClick={event => {
                                  event.preventDefault();
                                  fn_setProductType(rootStore, "menu", true);
                                  fn_salesProductSearch(rootStore);
                                  analyticeEvent(
                                    "productSalesSearch",
                                    "productSalesSearchMenu Button",
                                    rootStore.searchStore.getShopCd
                                  );
                                }}
                              >
                                <input
                                  type="radio"
                                  name="product"
                                  readOnly={true}
                                  checked={fn_getProductType(rootStore).menu === true}
                                />
                                <span className="txt befor">메뉴</span>
                              </label>
                              <label
                                onClick={event => {
                                  event.preventDefault();
                                  fn_setProductType(rootStore, "option", true);
                                  fn_salesProductSearch(rootStore);
                                  analyticeEvent(
                                    "productSalesSearch",
                                    "productSalesSearchOption Button",
                                    rootStore.searchStore.getShopCd
                                  );
                                }}
                              >
                                <input
                                  type="radio"
                                  name="product"
                                  readOnly={true}
                                  checked={fn_getProductType(rootStore).option === true}
                                />
                                <span className="txt week">옵션</span>
                              </label>
                              <div className="info">* 배민, 배민1 옵션 금액은 메뉴 매출에 포함됩니다</div>
                            </div>
                            <div className="tit">가격유형</div>
                            <div className="selects">
                              <label
                                onClick={event => {
                                  event.preventDefault();
                                  fn_setPriceType(rootStore, "all", true);
                                  fn_salesProductSearch(rootStore);
                                  analyticeEvent(
                                    "productSalesSearch",
                                    "productSalesSearchAllPrice Button",
                                    rootStore.searchStore.getShopCd
                                  );
                                }}
                              >
                                <input
                                  type="radio"
                                  name="price"
                                  readOnly={true}
                                  checked={fn_getPriceType(rootStore).all === true}
                                />
                                <span className="txt today">전체</span>
                              </label>
                              <label
                                onClick={event => {
                                  event.preventDefault();
                                  fn_setPriceType(rootStore, "charge", true);
                                  fn_salesProductSearch(rootStore);
                                  analyticeEvent(
                                    "productSalesSearch",
                                    "productSalesSearchPaid Button",
                                    rootStore.searchStore.getShopCd
                                  );
                                }}
                              >
                                <input
                                  type="radio"
                                  name="price"
                                  readOnly={true}
                                  checked={fn_getPriceType(rootStore).charge === true}
                                />
                                <span className="txt befor">유료</span>
                              </label>
                              <label
                                onClick={event => {
                                  event.preventDefault();
                                  fn_setPriceType(rootStore, "free", true);
                                  fn_salesProductSearch(rootStore);
                                  analyticeEvent(
                                    "productSalesSearch",
                                    "productSalesSearchFree Button",
                                    rootStore.searchStore.getShopCd
                                  );
                                }}
                              >
                                <input
                                  type="radio"
                                  name="price"
                                  readOnly={true}
                                  checked={fn_getPriceType(rootStore).free === true}
                                />
                                <span className="txt week">무료</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="sub">
                          <div className="total_info">
                            <div className="cnt">
                              <span className="bar"></span>
                              <span className="totalTit">총 판매수량</span>
                              <span className="totalTxt">
                                {salesStore.getTotalSalesVal.totalSaleCount != 0
                                  ? commaString(salesStore.getTotalSalesVal.totalSaleCount)
                                  : 0}{" "}
                                개
                              </span>
                            </div>
                            <div className="amount">
                              <span className="bar"></span>
                              <span className="totalTit">총 매출금액</span>
                              <span className="totalTxt">
                                {salesStore.getTotalSalesVal.totalSaleAmount != 0
                                  ? commaString(salesStore.getTotalSalesVal.totalSaleAmount)
                                  : 0}{" "}
                                원
                              </span>
                            </div>
                          </div>
                          <div className="btn_box">
                            <button
                              type="submit"
                              className="etc_sales"
                              onClick={event => {
                                event.preventDefault();
                                fn_productSalesEtcList(rootStore);
                                fn_product_etc_pop(rootStore, true);
                                analyticeEvent(
                                  "productSalesSearch",
                                  "productSalesMissing",
                                  rootStore.searchStore.getShopCd
                                );
                              }}
                            >
                              누락상품 조회
                            </button>
                            <button
                              type="submit"
                              className="excel_save"
                              onClick={event => {
                                event.preventDefault();
                                fn_productSalesExcelList(rootStore);
                                analyticeEvent(
                                  "productSalesSearch",
                                  "productSalesExcel",
                                  rootStore.searchStore.getShopCd
                                );
                              }}
                            >
                              <span className="ico"></span>엑셀 저장
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="wrap_table">
                        <table>
                          <thead>
                            <tr>
                              <th rowSpan="2">NO</th>
                              <th
                                className="name"
                                rowSpan="2"
                                onClick={event => {
                                  event.preventDefault();
                                  this.sortClick("orderByProductName");
                                  analyticeEvent(
                                    "productSalesSearch",
                                    "productSalesNameSort",
                                    rootStore.searchStore.getShopCd
                                  );
                                }}
                              >
                                상품명
                                <span
                                  className={
                                    salesStore.getSortTypeVal.orderByProductName.viewType == "asc" &&
                                    salesStore.getSortTypeVal.orderByProductName.status == true
                                      ? "sort_up on"
                                      : "sort_up"
                                  }
                                ></span>
                                <span
                                  className={
                                    salesStore.getSortTypeVal.orderByProductName.viewType == "desc" &&
                                    salesStore.getSortTypeVal.orderByProductName.status == true
                                      ? "sort_down on"
                                      : "sort_down"
                                  }
                                ></span>
                              </th>
                              <th className="type" rowSpan="2">
                                상품유형
                              </th>
                              <th
                                className="colspan"
                                colSpan="2"
                                onClick={event => {
                                  event.preventDefault();
                                  this.sortClick("orderBySaleVolume");
                                  analyticeEvent(
                                    "productSalesSearch",
                                    "productSalesQuantitySort",
                                    rootStore.searchStore.getShopCd
                                  );
                                }}
                              >
                                판매수량
                                <span
                                  className={
                                    salesStore.getSortTypeVal.orderBySaleVolume.viewType == "asc" &&
                                    salesStore.getSortTypeVal.orderBySaleVolume.status == true
                                      ? "sort_up on"
                                      : "sort_up"
                                  }
                                ></span>
                                <span
                                  className={
                                    salesStore.getSortTypeVal.orderBySaleVolume.viewType == "desc" &&
                                    salesStore.getSortTypeVal.orderBySaleVolume.status == true
                                      ? "sort_down on"
                                      : "sort_down"
                                  }
                                ></span>
                              </th>
                              <th
                                className="colspan"
                                colSpan="2"
                                onClick={event => {
                                  event.preventDefault();
                                  this.sortClick("orderBySaleAmount");
                                  analyticeEvent(
                                    "productSalesSearch",
                                    "productSalesRevenueSort",
                                    rootStore.searchStore.getShopCd
                                  );
                                }}
                              >
                                매출금액
                                <span
                                  className={
                                    salesStore.getSortTypeVal.orderBySaleAmount.viewType == "asc" &&
                                    salesStore.getSortTypeVal.orderBySaleAmount.status == true
                                      ? "sort_up on sales"
                                      : "sort_up sales"
                                  }
                                ></span>
                                <span
                                  className={
                                    salesStore.getSortTypeVal.orderBySaleAmount.viewType == "desc" &&
                                    salesStore.getSortTypeVal.orderBySaleAmount.status == true
                                      ? "sort_down on sales"
                                      : "sort_down sales"
                                  }
                                ></span>
                              </th>
                              <th rowSpan="2">주문채널</th>
                            </tr>
                            <tr>
                              <th
                                className="short"
                                onClick={event => {
                                  event.preventDefault();
                                  this.sortClick("orderBySaleVolume");
                                }}
                              >
                                판매량
                              </th>
                              <th
                                className="short"
                                onClick={event => {
                                  event.preventDefault();
                                  this.sortClick("orderBySaleVolume");
                                }}
                              >
                                점유율
                              </th>
                              <th
                                className="long"
                                onClick={event => {
                                  event.preventDefault();
                                  this.sortClick("orderBySaleAmount");
                                }}
                              >
                                매출액
                              </th>
                              <th
                                className="short"
                                onClick={event => {
                                  event.preventDefault();
                                  this.sortClick("orderBySaleAmount");
                                }}
                              >
                                점유율
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(salesStore.getSalesProductList) && salesStore.getSalesProductList.length ? (
                              salesStore.getSalesProductList.map((sales, idx) => (
                                <SalesProductItemView key={idx} rootStore={rootStore} sales={sales} />
                              ))
                            ) : (
                              <tr>
                                <td className="empty" colSpan="10">
                                  <span></span>
                                  <br />
                                  <b>조회된 내역이 없습니다.</b>
                                  <br />
                                  <b>검색조건을 다시 확인해 주세요.</b>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        {Array.isArray(salesStore.getSalesProductList) && salesStore.getSalesProductList.length ? (
                          <SalesPagingBottomView rootStore={rootStore} />
                        ) : null}
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="wrap manager" id="manager_wrap">
                      <p className="auth tit">
                        <span></span>관리자(점주) 인증이 필요해요
                      </p>
                      <p className="auth txt">점주님 권한의 계정 인증 시에만 페이지를 조회할 수 있어요</p>
                      <div className="auth_btn_wrap">
                        <button
                          className="auth btn"
                          onClick={event => {
                            event.preventDefault();
                            fn_auth_pop(rootStore);
                          }}
                        >
                          관리자 인증하기 <span></span>
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="sales close">
              <Link to="/">
                <button type="button">
                  <span className="btn_order_history_close">닫기</span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SalesProduct;
